import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Redirect, Route } from 'react-router-dom'

import MainApp from '../../components/Layout/MainApp'
import { setCurrentAppId, loadCurrentApplicationRequest } from '../../redux/Ekko/actions'

class PrivateRoute extends React.Component {
    compareAndSaveAppId = match => {
        const { setCurrentAppId, loadCurrentApplication, currentAppId } = this.props
        const appIdParam = match.params.app_id

        if (appIdParam && currentAppId !== appIdParam) {
            setCurrentAppId(appIdParam)
            loadCurrentApplication()
        }
    }

    render() {
        const { isAuthorized, component: Component, ...rest } = this.props

        return (
            <Route
                {...rest}
                render={props => {
                    const showSidebar = props.location.pathname.split('/').length > 2
                    this.compareAndSaveAppId(props.match)

                    return isAuthorized ? (
                        <MainApp showSidebar={showSidebar}>
                            <Component {...props} />
                        </MainApp>
                    ) : (
                        <Redirect push to="/signin" />
                    )
                }}
            />
        )
    }
}

const mapStateToProps = state => ({
    isAuthorized: state.admin.isAuthorized,
    currentAppId: state.ekko.currentAppId
})

const mapActionsToProps = dispatch => ({
    setCurrentAppId: bindActionCreators(setCurrentAppId, dispatch),
    loadCurrentApplication: bindActionCreators(loadCurrentApplicationRequest, dispatch)
})

export default connect(
    mapStateToProps,
    mapActionsToProps
)(PrivateRoute)
